import {css} from '@emotion/react'

export default css({
    padding: 8,
})
